import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  FormControl,
  IconButton,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { UserStatusChange } from "../redux/Actions/userStatusService";

const UserstatusModal = ({ openUserModal, setopenUserModal, selectedUser }) => {
  const dispatch = useDispatch();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [submitError, setSubmitError] = useState(false);
  const [allowedStatusOptions, setAllowedStatusOptions] = useState([]);

  useEffect(() => {
    setSelectedStatus("");
    setSubmitError(false);
    if (
      selectedUser?.userStatus &&
      selectedUser.userStatus.toLowerCase().includes("APPROVED")
    ) {
      setAllowedStatusOptions(["SUSPENDED", "BLOCKED"]);
    } else if (
      selectedUser?.userStatus &&
      selectedUser.userStatus.toLowerCase().includes("pending")
    ) {
      setAllowedStatusOptions(["APPROVED", "SUSPENDED", "BLOCKED"]);
    } else if (
      selectedUser?.userStatus &&
      selectedUser.userStatus.toLowerCase().includes("suspended")
    ) {
      setAllowedStatusOptions(["APPROVED", "PENDING", "BLOCKED"]);
    } else if (
      selectedUser?.userStatus &&
      selectedUser.userStatus.toLowerCase().includes("blocked")
    ) {
      setAllowedStatusOptions(["APPROVED", "PENDING", "SUSPENDED"]);
    }
  }, [selectedUser]);

  const handleClose = () => {
    setopenUserModal(false);
    setSelectedStatus("");
    setSubmitError(false);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };


  const handleSubmit = () => {
    if (!selectedStatus) {
      setSubmitError(true);
      return;
    }

    if (allowedStatusOptions.includes(selectedStatus)) {
      const statusObj = {
        userId: selectedUser?.userId,
        userStatus: selectedStatus,
      };
      dispatch(UserStatusChange(statusObj));
      handleClose();
    }
  };

  return (
    <div>
      <Modal open={openUserModal} onClose={handleClose}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            backgroundColor: "white",
            padding: 20,
            borderRadius: 5,
            textAlign: "center",
          }}
        >
          <IconButton
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <TextField
            label="User Account Status"
            value={selectedUser?.userStatus}
            fullWidth
            disabled
            sx={{ marginTop: 5 }}
          />
          <FormControl fullWidth style={{ marginTop: 20 }}>
            {allowedStatusOptions.map((option) => (
              <FormControlLabel
                key={option}
                control={
                  <Checkbox
                    checked={selectedStatus === option}
                    onChange={handleStatusChange}
                    value={option}
                  />
                }
                label={option}
              />
            ))}
            {submitError && (
              <Typography variant="caption" color="error">
                Please choose a status before submitting.
              </Typography>
            )}
          </FormControl>
          <div style={{ marginTop: 20 }}>
            <Button
              variant="contained"
              style={{ marginRight: 10 }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
            <Button variant="contained" onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UserstatusModal;
